import React, { useState } from "react";
import "./ProfileContent.css";
import useAuthentication from "../../../hooks/auth/UseAuthentification";
import EmailIcon from "@mui/icons-material/Email";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { assets } from "../../../publics/assets";
import { Collapse } from "react-collapse";
import { RotateLoader } from "react-spinners";
import { Box } from "@mui/material";
import AvatarUser from "../../atoms/avatarUser/AvatarUser";
import ConfirmationModal from "../confirmationModal/ConfiramationModal";
import CustomForm from "../customForm/CustomForm";
import { useAccessRights } from "../../../hooks/userPermissions/useAccessRights";
const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL;

const ProfileContent = ({
  logout,
  updateProfile,
  updatePassword,
  triggerTooltip,
  isSmallScreen,
  openSection,
}) => {
  const auth = useAuthentication();
  const { canAccessLayer } = useAccessRights();
  const canOpenDashboard = canAccessLayer("auth", "login_dashboard");
  const [isEditable, setIsEditable] = useState(false);
  const [changePwd, setChangePwd] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [formData, setFormData] = useState({
    id: auth.user.id,
    username: auth.user.username,
    email: auth.user.email,
    name: auth.user.name,
    lastname: auth.user.lastname,
    adress: auth.user.adress,
    country: auth.user.country,
    city: auth.user.city,
    organization: auth.user.organization,
    role: auth.user.role,
  });
  const [passwordData, setPasswordData] = useState({
    currentPwd: "",
    newPwd: "",
    confirmedPwd: "",
  });
  const openAdminDashboard = () => {
    window.open(DASHBOARD_URL, "_blank", "noopener,noreferrer");
  };
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // Handle password input changes
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // Password validation function
  const validatePassword = (password) => {
    const minLength = 8;
    const upperCasePattern = /[A-Z]/;
    const lowerCasePattern = /[a-z]/;
    const numberPattern = /[0-9]/;
    const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;

    if (password.length < minLength) {
      triggerTooltip("Le mot de passe doit contenir au moins 8 caractères.");
      return false; // Prevent form submission
    }
    if (!upperCasePattern.test(password)) {
      triggerTooltip(
        "Le mot de passe doit contenir au moins une lettre majuscule.",
      );
      return false;
    }
    if (!lowerCasePattern.test(password)) {
      triggerTooltip(
        "Le mot de passe doit contenir au moins une lettre minuscule.",
      );
      return false;
    }
    if (!numberPattern.test(password)) {
      triggerTooltip("Le mot de passe doit contenir au moins un chiffre.");
      return false;
    }
    if (!specialCharPattern.test(password)) {
      triggerTooltip(
        "Le mot de passe doit contenir au moins un caractère spécial.",
      );
      return false;
    }
    return true; // Valid password
  };

  // Handle password change
  const handleSavePassword = async (e) => {
    //e.preventDefault();

    // Check if the password fields are not empty
    if (
      !passwordData.currentPwd ||
      !passwordData.newPwd ||
      !passwordData.confirmedPwd
    ) {
      triggerTooltip("Veuillez remplir tous les champs.");
      return;
    }

    // Validate new password
    if (!validatePassword(passwordData.newPwd)) {
      return; //if validation fails and prevent form submission
    }

    // Check if new password and confirmed password match
    if (passwordData.newPwd !== passwordData.confirmedPwd) {
      triggerTooltip("Les mots de passe ne correspondent pas.");
      return;
    }

    try {
      const updatedPassword = await updatePassword(
        passwordData.currentPwd,
        passwordData.newPwd,
        auth.user.id,
        auth.accessToken,
      );
      setChangePwd(false);
      setPasswordData({ currentPwd: "", newPwd: "", confirmedPwd: "" }); // Reset fields
    } catch (error) {
      console.error("Failed to update password:", error);
    }
  };

  // Handle form submission (sending to backend the modifies userdata)
  const handleSubmitProfileModif = async (e) => {
    //e.preventDefault();  Prevent default form submission

    try {
      const updatedUser = await updateProfile(formData, auth.accessToken);
      setIsEditable(false); // Disable editing after saving
    } catch (error) {
      console.error("Failed to update profile:", error);
    }
  };
  const handleSaveClick = () => {
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    if (changePwd) {
      handleSavePassword();
    } else {
      handleSubmitProfileModif();
    }
    setShowConfirmation(false);
  };

  const handleCancelConfirm = () => {
    setShowConfirmation(false);
    if (changePwd) {
      resetPwdModification();
    } else {
      resetProfileModification();
    }
  };
  const resetProfileModification = () => {
    setIsEditable(false);
    setFormData({
      id: auth.user.id,
      username: auth.user.username,
      email: auth.user.email,
      name: auth.user.name,
      lastname: auth.user.lastname,
      adress: auth.user.adress,
      country: auth.user.country,
      city: auth.user.city,
      organization: auth.user.organization,
      password: "",
      role: auth.user.role,
    });
  };
  const resetPwdModification = () => {
    setPasswordData({
      currentPwd: "",
      newPwd: "",
      confirmedPwd: "",
    });
    setChangePwd(false);
  };
  const passwordFormInputs = [
    [
      {
        label: "Mot de passe actuelle",
        name: "currentPwd",
        type: "text",
        className: "profile-input-style",
        value: passwordData.currentPwd,
        onChange: handlePasswordChange,
        placeholder: "Entrer votre mot de passe",
      },
    ],
    [
      {
        label: "Nouveau mot de passe",
        name: "newPwd",
        type: "text",
        className: "profile-input-style",
        value: passwordData.newPwd,
        onChange: handlePasswordChange,
        placeholder: "Entrer nouveau mot de passe",
      },
    ],
    [
      {
        label: "Confirmer nouveau mot de passe",
        name: "confirmedPwd",
        type: "text",
        className: "profile-input-style",
        value: passwordData.confirmedPwd,
        onChange: handlePasswordChange,
        placeholder: "Confirmer nouveau mot de passe",
      },
    ],
  ];

  const profileFormInputs = [
    // First row (2 inputs)
    [
      {
        label: "Nom utilisateur",
        name: "username",
        type: "text",
        className: "profile-input-style",
        value: formData.username,
        onChange: handleChange,
        disabled: !isEditable,
      },
      {
        label: "Email",
        name: "email",
        type: "email",
        className: "profile-input-style",
        value: formData.email,
        onChange: handleChange,
        disabled: !isEditable,
      },
    ],
    // Second row (2 inputs)
    [
      {
        label: "Nom",
        name: "lastname",
        type: "text",
        className: "profile-input-style",
        value: formData.lastname,
        onChange: handleChange,
        disabled: !isEditable,
      },
      {
        label: "Prénom",
        name: "name",
        type: "text",
        className: "profile-input-style",
        value: formData.name,
        onChange: handleChange,
        disabled: !isEditable,
      },
    ],
    // Third row (2 inputs)
    [
      {
        label: "Organisation",
        name: "organization",
        type: "text",
        className: "profile-input-style",
        value: formData.organization,
        onChange: handleChange,
        disabled: !isEditable,
      },
      {
        label: "Rôle",
        name: "role",
        type: "text",
        className: "profile-input-style",
        value: formData.role,
        onChange: handleChange,
        disabled: !isEditable,
      },
    ],
    // Fourth row (1 input)
    [
      {
        label: "Adresse",
        name: "adress",
        type: "text",
        className: "profile-input-style",
        value: formData.adress,
        onChange: handleChange,
        disabled: !isEditable,
      },
    ],
    // Fifth row (2 inputs)
    [
      {
        label: "Pays",
        name: "country",
        type: "text",
        className: "profile-input-style",
        value: formData.country,
        onChange: handleChange,
        disabled: !isEditable,
      },
      {
        label: "Ville",
        name: "city",
        type: "text",
        className: "profile-input-style",
        value: formData.city,
        onChange: handleChange,
        disabled: !isEditable,
      },
    ],
  ];
  return (
    <>
      {isSmallScreen ? (
        <div>
          <Collapse isOpened={openSection === "profile"}>
            {!auth.user ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                marginBottom="30%"
              >
                <RotateLoader color="#b10511" loading={true} size={20} />{" "}
              </Box>
            ) : (
              <div className="profile-container">
                <div className="user-infos-container">
                  <div className="user-infos-photo">
                    <AvatarUser />
                    {/*<img
                      src={assets.userPhoto}
                      alt="logo"
                      className="avatar-img"
                    />*/}
                  </div>
                </div>
                {!changePwd ? (
                  <CustomForm
                    formClassName="profile-form"
                    inputsConfig={profileFormInputs}
                  />
                ) : (
                  <CustomForm
                    formClassName="pwd-form"
                    inputsConfig={passwordFormInputs}
                  />
                )}

                <div className="profile-btns">
                  {!(isEditable || changePwd) ? (
                    <>
                    {canOpenDashboard && (
                    <button
                      className="profile-dashboard-btn"
                      onClick={openAdminDashboard}
                      data-testid="profile-dashboard-button"
                    >
                      Accéder au dashboard admin {" "}
                      <OpenInNewIcon style={{ fontSize: "16px" }} />
                    </button>
                  )}
                      <button
                        className="profile-edit-btn"
                        onClick={() => setChangePwd(true)}
                         data-testid="profile-change-password-button"
                      >
                        Changer MDP
                      </button>
                    
                    </>
                  ) : (
                    <>
                      <button
                        className="profile-edit-btn"
                        onClick={handleSaveClick}
                        data-testid="profile-save-button"
                      >
                        Sauvgarder
                      </button>
                      <button
                        className="profile-logout-btn"
                        onClick={() =>
                          changePwd
                            ? resetPwdModification()
                            : resetProfileModification()
                        }
                        data-testid="profile-cancel-button"
                      >
                        Annuler
                        <ArrowForwardIcon
                          style={{ fontSize: "16px", marginLeft: "4px" }}
                        />
                      </button>
                    </>
                  )}
                </div>
              </div>
            )}
          </Collapse>
        </div>
      ) : (
        <div>
          {!auth.user ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              marginBottom="30%"
            >
              <RotateLoader color="#b10511" loading={true} size={20} />{" "}
            </Box>
          ) : (
            <div className="profile-container">
              <div className="user-infos-container">
                <div className="user-infos-photo">
                  <AvatarUser />
                  {/* <img
                    src={assets.userPhoto}
                    alt="logo"
                    className="avatar-img"
                  /> */}
                </div>
                <div className="user-infos">
                  <div className="user-infos-item">
                    <AccountCircleIcon style={{ fontSize: "18px" }} />
                    <p>{auth.user.username}</p>
                  </div>
                  <div className="user-infos-item">
                    <HomeRepairServiceIcon style={{ fontSize: "18px" }} />
                    <p>{auth.user.role}</p>
                  </div>
                  <div className="user-infos-item">
                    <EmailIcon style={{ fontSize: "18px" }} />
                    <p>{auth.user.email}</p>
                  </div>
                  {canOpenDashboard && (
                    <button
                      className="profile-dashboard-btn"
                      onClick={openAdminDashboard}
                      data-testid="profile-dashboard-button"
                    >
                      Accéder au dashboard admin {" "}
                      <OpenInNewIcon style={{ fontSize: "16px" }} />
                    </button>
                  )}
                </div>
              </div>
              {!changePwd ? (
                <CustomForm
                  formClassName="profile-form"
                  inputsConfig={profileFormInputs}
                />
              ) : (
                <CustomForm
                  formClassName="pwd-form"
                  inputsConfig={passwordFormInputs}
                />
              )}

              <div className="profile-btns">
                {!(isEditable || changePwd) ? (
                  <>
                    <button
                      className="profile-edit-btn"
                      onClick={() => setChangePwd(true)}
                      data-testid="profile-change-password-button"
                    >
                      Changer MDP
                    </button>
                    <button className="profile-logout-btn" onClick={logout} data-testid="profile-logout-button">
                      Déconnexion
                      <ArrowForwardIcon
                        style={{ fontSize: "16px", marginLeft: "4px" }}
                      />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="profile-edit-btn"
                      onClick={handleSaveClick}
                       data-testid="profile-save-button"
                    >
                      Sauvgarder
                    </button>
                    <button
                      className="profile-logout-btn"
                      onClick={() =>
                        changePwd
                          ? resetPwdModification()
                          : resetProfileModification()
                      }
                      data-testid="profile-cancel-button"
                    >
                      Annuler
                      <ArrowForwardIcon
                        style={{ fontSize: "16px", marginLeft: "4px" }}
                      />
                    </button>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <ConfirmationModal
        open={showConfirmation}
        onClose={handleCancelConfirm}
        onConfirm={handleConfirm}
        title="Confirmation des modifications"
        message="Êtes-vous sûr de vouloir enregistrer ces modifications ? "
      />
    </>
  );
};

export default ProfileContent;
